import { useAuth } from 'react-oidc-context';

/**
 * The bearer token the API takes, or '' before sign-in completes: BlueSphere
 * Identity's **access** token, holding `mdr/api` (ADR-0034 §1). Identity's
 * ID tokens are refused.
 */
export function useAccessToken(): string {
  const auth = useAuth();
  return auth.user?.access_token ?? '';
}
